import React from 'react'
import styles from './styles.css'
import MdPauseCircleOutline from 'react-icons/lib/md/pause-circle-outline'
import Button from 'orionsoft-parts/lib/components/Button'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router'
import SendButton from './SendButton'

@withRouter
export default class OwnerButtons extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    router: PropTypes.object,
    document: PropTypes.object
  }

  state = {}

  renderDocState() {
    return (
      <div className="col-xs-12 col-md-8 start-md">
        <div className={styles.state}>
          <MdPauseCircleOutline size={30} style={{color: '#e4ac00'}} />
          El documento aún no ha sido enviado a firmar
        </div>
      </div>
    )
  }

  renderEditButton() {
    return (
      <div className="col-xs-12 col-md-6 start-md">
        <Button
          tooltip="Volver a preparar"
          disabled={this.state.loading}
          onClick={() => this.props.router.push(`/sign/prepare/${this.props.document._id}`)}
          style={{marginRight: 10}}
        >
          Editar
        </Button>
      </div>
    )
  }

  renderFillFields() {
    return (
      <div className="col-xs-12 col-sm-6 start-md">
        <Button
          onClick={() =>
            this.props.router.push(`/documents/${this.props.document._id}/fillnamefields`)
          }
        >
        Rellenar campos
        </Button>
      </div>
    )
  }

  renderSend() {
    return (
      <div className="col-xs-12 col-sm-6 end-md">
        <SendButton document={this.props.document} />
      </div>
    )
  }

  // renderCopyURL() {
  //   return (
  //     <div className="col-xs-12 col-md-4 end-md">
  //       <p>
  //         <CopyToClipboard text={window.location.href}
  //           onCopy={() => this.setState({copied: true})}>
  //           <Button primary><MdContentCopy size={20} style={{color: '#3cb371'}} />&nbsp;Copiar Url</Button>
  //         </CopyToClipboard>
  //       </p>
  //     </div>
  //   )
  // }

  render() {
    return (
      <div className="content">
        <div className="row">
          {this.renderDocState()}
          {/* {this.renderCopyURL()} */}
        </div>
        <div className="row">
          {this.renderEditButton()}
        </div>
        <div className="row"><p></p></div>
        <div className="row">
          {this.renderFillFields()}
          {this.renderSend()}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/SendToSign/OwnerView/Buttons/OwnerButtons/index.js